import { render, staticRenderFns } from "./Acompanantes.vue?vue&type=template&id=2011444d"
import script from "./Acompanantes.vue?vue&type=script&lang=js"
export * from "./Acompanantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports